import { createApp } from 'vue'
import { createPinia } from 'pinia'
import JsonViewer from 'vue-json-viewer'
import App from './App.vue'
import Antd from 'ant-design-vue'


import '@/overwrite_ant.less'
import router from './router'
import store from './store'
console.log('Kun Wu submitted and built at 2021-09-25')

import hevueImgPreview from 'hevue-img-preview'

const app = createApp(App)
import 'ant-design-vue/dist/antd.less'
app.config.productionTip = false
app.use(Antd)
app.use(hevueImgPreview,{
  // keyboard: true,
  // clickMaskCLose: true
})

app.use(JsonViewer)
app.use(createPinia())
app.use(store).use(router).mount('#app')
